import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({ className, ...props }, ref) => (
  <label className="inline-flex items-center gap-2">
    <span className="relative inline-flex h-5 w-5 items-center justify-center">
      <input
        ref={ref}
        type="checkbox"
        className={cn("peer h-5 w-5 appearance-none rounded border-2 border-input bg-white checked:border-accent checked:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring", className)}
        {...props}
      />
      <Check className="pointer-events-none absolute h-3.5 w-3.5 text-accent-foreground opacity-0 peer-checked:opacity-100" />
    </span>
  </label>
));
Checkbox.displayName = "Checkbox";

export { Checkbox };
